import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { MargemMOService } from '../margem-mo-service/margem-mo.service';
import { ConversaoLibraConverte } from './../../../../shared/conversao-libra/conversao-libra-converte';
import { ListaBase } from './../../../../shared/crud/ListaBase';
import { EstruturaGridViewBuilder } from './../../../../shared/gridview/EstruturaGridViewBuilder';

@Component({
  selector: 'app-margem-mo-lista',
  templateUrl: '../../template/lista.html',
  styleUrls: ['./margem-mo-lista.component.css']
})
export class MargemMOListaComponent
  extends ListaBase
  implements OnInit {
  visualizarTotalRegistros: boolean;
  exibirBotaoDetalhes: boolean;
  subscription;

  constructor(service: MargemMOService, 
    toastr: ToastrService, 
    router: Router,
    private translate: TranslateService,
    private conversaoLibraConverte: ConversaoLibraConverte) {
    super(service, toastr, router);
    this.visualizarTotalRegistros = true;
    this.listagemComPaginacao = true;
    this.quantidadeRegistrosPorPagina = 5;
    this.exibirBotaoDetalhes = true;
  }

  ngOnInit() {
    this.buscar();
    this.estrutura = new EstruturaGridViewBuilder()
      .addColuna("nome_dealer", 'Dealer')
      .addColuna("ano", 'parametros.margemMO.ano')
      .addColuna("mes", 'parametros.margemMO.mes')
      .addColuna("valor", 'parametros.margemMO.valor')
      .build();

    //conversaolibra
    this.conversaoLibraConverte.preencher();
    this.subscription = this.translate.onLangChange
      .subscribe((event: LangChangeEvent) => {
          this.buscar();
      });
    //fimConversaolibra
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  protected getListagemComFiltros(): boolean {
    return this.filtros.id
      || this.filtros.nome_dealer;
  }

  getDados(response: any): any {

    response.dados.forEach(element => {
      element.valor = this.conversaoLibraConverte.conversaoLibra(element.valor, null, null).toFixed(2);
    });

    return response.dados;
  }
}
